module.exports = __webpack_public_path__ + "img/measurement_info_left_ankle.8642d22f.jpg";